import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-ci",
  "use": "icon-icon-ci-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-ci\">\n  <g fill-rule=\"evenodd\">\n    <path fill=\"#00cd00\" d=\"M341.5 0H512v512H341.5z\" />\n    <path fill=\"#ff9a00\" d=\"M0 0h170.3v512H0z\" />\n    <path fill=\"#fff\" d=\"M170.3 0h171.2v512H170.3z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol